module.exports = __webpack_public_path__ + "static/media/apiko-logo.e0b96e79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/imgs/apiko-logo.svg
// module id = 893
// module chunks = 18